var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIwbLogoProject1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 56,
    viewBox: "0 0 117 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3617_1356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.18 0H9.7C4.34284 0 0 4.34284 0 9.7V45.5C0 50.8572 4.34284 55.2 9.7 55.2H107.18C112.537 55.2 116.88 50.8572 116.88 45.5V9.7C116.88 4.34284 112.537 0 107.18 0Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8799 15.04V39.57H42.4099V15.04H17.8799ZM31.6599 34.53H28.6299V20.08H31.6599V34.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0898 15.04V39.57H70.6198V15.04H46.0898ZM64.2398 34.53H60.7998L58.5198 24.33C58.4598 24 58.3998 23.72 58.3798 23.37H58.2998C58.2798 23.72 58.2598 24 58.1998 24.33L55.9198 34.53H52.4798L48.9798 20.08H52.0498L54.1098 30.07C54.1898 30.52 54.2298 30.82 54.2498 31.17H54.3098C54.3298 30.84 54.3898 30.52 54.4898 30.07L56.8298 20.08H59.8798L62.2398 30.07C62.3398 30.52 62.3798 30.84 62.3998 31.17H62.4598C62.4798 30.82 62.4998 30.52 62.5998 30.07L64.6598 20.08H67.7298L64.2298 34.53H64.2398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9999 24.2103C89.9999 23.1703 89.3899 22.2803 87.6599 22.2803H85.0999V26.1103H87.6599C89.4499 26.1103 89.9999 25.1903 89.9999 24.2203V24.2103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0198 28.22H85.0898V32.33H87.9198C89.6698 32.33 90.3598 31.37 90.3598 30.23C90.3598 29.03 89.6098 28.21 88.0198 28.21V28.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5898 15.04V39.57H99.1199V15.04H74.5898ZM88.6298 34.53H82.0499V20.08H88.3198C91.7598 20.08 93.1199 21.83 93.1199 23.83C93.1199 25.32 92.2398 26.58 90.5798 27.03C92.4098 27.31 93.5098 28.58 93.5098 30.51C93.5098 32.67 92.0198 34.54 88.6199 34.54L88.6298 34.53Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3617_1356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.88,
    height: 55.2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwbLogoProject1);
export default __webpack_public_path__ + "static/media/IWB Logo Project 1.38d72453971c87361d89191076d9332e.svg";
export { ForwardRef as ReactComponent };